import { setUser } from "../actions/user";
import { setWarehouseList } from "../actions/warehouse";
import { reloadUser } from "../utils/functions";

import { axiosInstance } from "./apiInstance";
import urls from "./urls.json";

export const getPocList = (pageNo) => {
	const page = pageNo ? `?page=${pageNo}` : "";
	return (dispatch) =>
		axiosInstance
			.get(`/users/client/poc/${page}`)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					dispatch(setWarehouseList(response.data));
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const addPocAsync = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.addClientPOC, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const updatePOC = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`/users/client/poc/${obj.id}/`, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const deletePoc = (id) => (dispatch) =>
	axiosInstance
		.delete(`/users/client/poc/${id}`)
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: true,
						showReAuthModal: true,
						requestType: "delete",
					})
				);
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 204) {
				return true;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const addDeliveryPartner = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.createDeliveryPartner, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getDPFields = (delivery_partner_id, mode_id) => (dispatch) =>
	axiosInstance
		.get(`/dp/dpfields/${delivery_partner_id}/${mode_id}`)
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});
